export default __webpack_public_path__ + "static/media/manage-ams-collapse-active.7fce73c5.svg";